// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {DropMenu} from './index';

export function template(this: DropMenu) {
  const {visibility} = this.state;
  const direction = this.attr(`direction`);

  return (
    <div
      sel='.mp-drop-menu-body'
      attrs={{
        elref: `contentBody`,
      }}
      class={{
        [`is-direction-${direction}`]: true,
        [`is-${visibility}`]: true,
      }}
    >
      <slot
        on={{
          close: (ev: CustomEvent) => {
            ev.stopPropagation();
            this.close();
          },
        }}
      />
      {this.attr(`show-arrow`) && <div sel='.mp-drop-menu-arrow' />}
    </div>
  );
}
